{
  "app": {
    "name": "POSS",
    "legend": "Pacific One Stop Shop"
  },
  "dashboard": {
    "actualSituation": "Aktuelle Situation",
    "payments": "Zahlungen",
    "totalAmount": "Gesamtbetrag",
    "currentAccount": "Aktuelles Konto"
  },
  "config": {
    "tin": "PIN",
    "tinLegend": "POSS Identification Number"
  },
  "administration-user": {
    "title": {
      "page": "Benutzer",
      "page-taxpayer": "Mitwirkende"
    },
    "label": {
      "userName": "Nutzername",
      "department": "Abteilung",
      "roles": "Rollen",
      "user": "Neuer Benutzer",
      "disabled": "Deaktiviert",
      "locale": "Bevorzugte Sprache",
      "disable": "Etwas deaktivieren",
      "enable": "Aktivieren",
      "cancel": "Stornieren"
    },
    "validations": {
      "userName": "Ein Benutzername wird benötigt"
    },
    "messages": {
      "disableTitle": "Benutzer deaktivieren",
      "confirmDisable": "Möchten Sie diesen Benutzer wirklich deaktivieren?",
      "confirmEnable": "Möchten Sie diesen Benutzer wirklich aktivieren?",
      "savedSucessfully": "Erfolgreich gespeichert",
      "enableTitle": "Benutzer aktivieren",
      "error": "Error"
    }
  },
  "user-profile": {
    "title": {
      "page": "Benutzerprofil",
      "change-password": "Kennwort ändern"
    },
    "label": {
      "userName": "Nutzername",
      "name": "Name",
      "email": "Mail",
      "locale": "Bevorzugte Sprache",
      "currentPassword": "Jetziges Passwort",
      "newPassword": "Neues Kennwort",
      "repeatPassword": "Wiederhole das Passwort",
      "change-password": "Kennwort ändern",
      "password": "Passwort"
    },
    "message": {
      "password-changed": "das Passwort wurde erfolgreich geändert",
      "profile-updated": "Profil erfolgreich aktualisiert. Sie müssen sich erneut anmelden, um die Änderungen zu sehen",
      "password": "Aktualisieren Sie Ihr Kontopasswort, um die Sicherheit Ihres Kontos zu gewährleisten"
    }
  },
  "common": {
    "label": {
      "theme": "Thema",
      "captcha-placeholder": "Captcha eingeben",
      "feedback": "Rückmeldung",
      "logout": "Ausloggen",
      "print": "Zu drucken",
      "phoneNumberArea": "Bereich",
      "current-user": "Aktueller Benutzer",
      "user-profile": "Benutzerprofil",
      "name": "Name",
      "givenNames": "Namen",
      "surnames": "Nachnamen",
      "search": "Suchen",
      "clean": "Aufräumen",
      "create": "Neu",
      "ok": "Akzeptieren",
      "next": "Nächster",
      "cancel": "Stornieren",
      "back": "Hinter",
      "edit": "Bearbeiten",
      "actions": "Aktionen",
      "send": "Senden",
      "close": "Schließen",
      "add": "Hinzufügen",
      "email": "Mail",
      "phoneNumber": "Telefon",
      "id": "Gehen",
      "password": "Passwort",
      "state": "Deaktiviert",
      "translation": "Übersetzung",
      "language": "Idiom",
      "value": "Wert",
      "translatable": "Übersetzbar",
      "politicalDivision": "Politische Spaltung",
      "department": "Abteilung / Provinz / Staat",
      "city": "Stadt, Dorf",
      "zipCode": "Postleitzahl",
      "cellPhone": "Handy, Mobiltelefon",
      "personType": "Art von Person",
      "businessName": "Name oder sozialer Grund",
      "taxpayerName": "Name oder sozialer Grund",
      "tradeName": "Handelsname",
      "address": "Richtung",
      "country": "Land",
      "localization": "Ort",
      "website": "Webseite",
      "fileSearch": "Datei durchsuchen",
      "fileUpload": "Datei hochladen",
      "fileDownload": "Download-Datei",
      "noFileSelected": "Keine Datei ausgewählt",
      "fileRequirements": "PDF · Max. 9,6 MB",
      "fileUploading": "Wird hochgeladen...",
      "fileUploaded": "Hochgeladen",
      "fileUploadError": "Die Datei konnte nicht hochgeladen werden",
      "fileSelect": "Auswählen",
      "fileReplace": "Ersetzen",
      "fileRemove": "Entfernen",
      "fileRemoving": "Wird entfernt...",
      "fileRemoveError": "Die Datei konnte nicht entfernt werden",
      "dateFrom": "Stammen aus",
      "dateTo": "Datum bis",
      "noFound": "Es gibt kein Ergebnis",
      "taxReturnCurrency": "Erklärung Moneda",
      "page-showing": "Zeigen",
      "page-to": "zu",
      "page-of": "von",
      "page-entries": "Aufzeichnungen",
      "loading": "Laden ...",
      "error": "Fehler",
      "unableToLoad": "Daten konnten nicht geladen werden. Bitte versuchen Sie es erneut.",
      "retry": "Wiederholen",
      "currency": "Währung",
      "paymentMethod": "Zahlungsmethode",
      "attachment": "Anfügen",
      "paymentReference": "Weitere Informationen",
      "supportDocument": "Support-Dokument",
      "payment": "Zahlung",
      "backToHome": "Zurück nach oben",
      "bank": "Bank",
      "bankInformation": "Bankinformationen",
      "excel": "Excel",
      "days": {
        "monday": "Mo.",
        "tuesday": "Ma",
        "wednesday": "Mich",
        "thursday": "Do",
        "friday": "Fr.",
        "saturday": "Sa.",
        "sunday": "So"
      },
      "months": {
        "january": "Januar",
        "february": "Februar",
        "march": "März",
        "april": "April",
        "may": "Kann",
        "june": "Juni",
        "july": "Juli",
        "august": "August",
        "september": "September",
        "october": "Oktober",
        "november": "November",
        "december": "Dezember"
      }
    },
    "descriptions": {
      "taxReturnCurrency": "Währung, die für Erklärungen verwendet werden soll",
      "contactTaxIdNumber-tax": "Steueridentifikationsnummer des Kontakts im Wohnsitzland"
    },
    "button": {
      "add": "Hinzufügen",
      "edit": "Bearbeiten",
      "find": "Suchen",
      "cancel": "Stornieren",
      "delete": "Beseitigen, abschütteln",
      "save": "Behalten",
      "submitTaxReturn": "Steuererklärung einreichen",
      "clean": "Aufräumen",
      "new": "Neu",
      "show": "Uhr",
      "download": "Herunterladen",
      "file": "Anfügen",
      "previous": "Bisherige",
      "next": "Nächster",
      "send": "Senden",
      "translate": "Übersetzungen",
      "return": "Rückkehr",
      "continue": "Fortsetzen",
      "newVersion": "Neue Version"
    },
    "dialog": {
      "dialog-error": "Fehler",
      "table-title-header": "Mitteilungen",
      "warning-title": "Beachtung"
    },
    "messages": {
      "error-500": "Bei der Operation ist ein Fehler aufgetreten",
      "fileUpload": "Die Datei wurde erfolgreich hochgeladen",
      "fileUploadMaxSize": "Die Dokumentgröße darf 10 MB nicht überschreiten",
      "savedSucessfully": "Erfolgreich gespeichert",
      "deletedSucessfully": "Erfolgreich entfernt",
      "pleaseWait": "Warten Sie mal",
      "warningInactiveSession": "Achtung: Seit einiger Zeit wurde keine Aktivität festgestellt. Die Sitzung wird in 1 Minute geschlossen, wenn noch keine Aktivität erkannt wurde",
      "sessionIdleCountdown": "Ihre Sitzung wird in {{count}} Sekunden geschlossen.",
      "closingSession": "Abschlusssitzung ...",
      "warningCancelOperation": "Wenn Sie den Vorgang abbrechen, gehen die eingegebenen Daten verloren. Möchten Sie fortfahren?",
      "confirm": "Möchten Sie diese Aktion sicherstellen?",
      "feedback": "Vielen Dank für dein Feedback",
      "feedbackIntro": "Ihre Kommentare werden an die Verwaltung gesendet, um Ihre Erfahrungen mit dem System zu erfahren und Ihnen einen besseren Service bieten zu können.",
      "messageSent": "Nachricht erfolgreich gesendet"
    },
    "validations": {
      "nameRequired": "Das Feld Name ist erforderlich",
      "fieldRequired": "Dieses Feld ist erforderlich",
      "mapRequired": "Sie müssen eine Position auf der Karte auswählen",
      "numbersAndLetters": "Nur Zahlen und Buchstaben",
      "email": "Ungültige E-Mail",
      "minStringValue": "Das Feld muss mindestens {{min}} Zeichen enthalten",
      "maxStringValue": "Das Feld darf maximal {{max}} Zeichen enthalten",
      "minNumberValue": "Der Feldwert muss mindestens {{min}} sein",
      "maxNumberValue": "Der Feldwert muss maximal {{max}} sein",
      "urlInvalid": "Das URL-Format ist ungültig",
      "captchaValidationRequired": "Eine Captcha-Validierung ist erforderlich"
    },
    "languages": {
      "spanish": "Spanisch (Spanien)",
      "english": "Englisch (USA)"
    },
    "taxpayer-request-types": {
      "enroll": "Registrierung",
      "update": "Aktualisierung"
    },
    "taxpayer-request-states": {
      "pending": "Ohrring",
      "pending_additional_information": "Weitere Informationen ausstehend",
      "approved": "Genehmigt",
      "rejected": "Abgelehnt"
    },
    "taxreturn-types": {
      "original": "Original",
      "amending": "Berichtigung"
    },
    "taxreturn-status": {
      "pending": "Ohrring",
      "accepted": "Akzeptiert",
      "approved": "Genehmigt",
      "rejected": "Abgelehnt",
      "reconciled": "Abgestimmt"
    },
    "yes-no": {
      "yes": "Ja",
      "no": "NICHT"
    }
  },
  "parameters-catalog": {
    "title": {
      "catalogType": "Katalogtyp",
      "catalog": "Katalog"
    },
    "label": {
      "type": "Nett",
      "name": "Name",
      "description": "Beschreibung",
      "field": "Landschaft",
      "label": "Hashtag",
      "parent": "Papa",
      "newCatalogType": "neue Art von Katalog",
      "newCatalog": "Neuer Katalog",
      "code": "Code",
      "addDefinition": "Definition hinzufügen",
      "newDefinition": "Neue Definition",
      "extaFilds": "Zusätzliche Benutzerfelder",
      "addNameTraslation": "Übersetzung hinzufügen"
    },
    "validations": {
      "exists": "Der Datensatz ist bereits vorhanden",
      "letterNumberhyphen": "Es sind nur Buchstaben, Zahlen und Bindestriche zulässig"
    },
    "messages": {
      "languageExist": "Die Sprache wurde bereits hinzugefügt"
    }
  },
  "taxpayer-fields": {
    "title": {
      "page": "Mitwirkende Felder",
      "enabled": "aktiviert"
    },
    "header": {
      "fieldCode": "Code",
      "fieldName": "Name",
      "fieldSection": "Abschnitt",
      "actions": "aktiviert"
    },
    "messages": {
      "savedSucessfully": "Informationen erfolgreich gespeichert"
    }
  },
  "report-file": {
    "title": {
      "page": "Anhang zum ergänzenden Bericht",
      "dialog": "Bericht existiert bereits",
      "dialog-confirm": "Bericht senden"
    },
    "label": {
      "header": "Kopfteil",
      "description": "Beschreibung",
      "type": "Nett",
      "file": "Ergänzender Bericht",
      "loading": "Laden ...",
      "definition": "Dateidefinition (.csv, .xls, .xlsx)"
    },
    "button": {
      "attachment": "Bericht anhängen"
    },
    "messages": {
      "dialog": "Für den ausgewählten Zeitraum wurde bereits ein Bericht eingereicht. Möchten Sie den vorhandenen Bericht durch eine neue Version ersetzen?",
      "confirm": "Möchten Sie diese Aktion wirklich ausführen?",
      "successfully": "Der ergänzende Bericht mit dem Zeitraum [period] wurde zufriedenstellend an [createDate] gesendet.",
      "backToHome": "Zurück nach oben"
    }
  },
  "report-details": {
    "stateType": {
      "processing": "Wird bearbeitet",
      "error": "Fehler",
      "accepted": "Akzeptiert",
      "processed": "Verarbeite"
    },
    "title": {
      "page": "Konsultation von Berichten"
    },
    "label": {
      "reportNumber": "Berichtsnummer",
      "reportType": "Berichtstyp",
      "operations": "Art der Operation",
      "taxpayerNumber": "Steueridentifikationsnummer",
      "taxpayerName": "Name des Beitrags",
      "registrationDate": "Registrierungsdatum",
      "period": "Zeitraum",
      "reportName": "Berichtsname",
      "record": "Werte",
      "index": "Reihe",
      "type": "Nett",
      "active": "Aktiv",
      "taxReportState": "Zustand"
    }
  },
  "report-selection": {
    "label": {
      "fileReport": "Ergänzungsbericht einreichen",
      "report": "Bericht",
      "year": "Zeitraum"
    },
    "messages": {
      "reportVersionNotFound": "Berichtsversion nicht gefunden"
    }
  },
  "taxreturn-report": {
    "title": {
      "page": "Siehe Erklärungen"
    },
    "label": {
      "nit": "Steuer ID",
      "taxreturnNumber": "Deklarationsnummer",
      "country": "Land",
      "formId": "Bilden",
      "taxreturnType": "Deklarationstyp",
      "taxreturnStatus": "Zustand",
      "name": "Mitwirkender Name",
      "period": "Zeitraum",
      "periodFrom": "Stammen aus",
      "periodTo": "Datum bis",
      "active": "Aktiv",
      "overview": "Allgemeines",
      "taxreturn": "Erklärung",
      "createDate": "Datum",
      "approve": "Genehmigt",
      "comments": "Bemerkungen"
    },
    "header": {
      "actions": "Aktionen",
      "nit": "Steuer ID",
      "name": "Mitwirkender Name",
      "taxReturnNumber": "Deklarationsnummer",
      "createDate": "Datum",
      "taxreturnType": "Deklarationstyp",
      "taxreturnStatus": "Zustand",
      "form": "Bilden",
      "period": "Zeitraum",
      "active": "Aktiv",
      "rejectionReason": "Grund für die Ablehnung"
    },
    "validations": {},
    "messages": {},
    "button": {}
  },
  "form-cells": {
    "title": {
      "page": "Boxen",
      "serviceParameters": "Service-Parameter"
    },
    "label": {
      "code": "Box Code",
      "name": "Namensfeld",
      "description": "Beschreibung",
      "section": "Abschnitt",
      "formula": "Formel",
      "order": "Auftrag",
      "type": "Nett",
      "service": "Bedienung",
      "mandatory": "Verpflichtend",
      "editable": "Bearbeitbar",
      "visible": "Sichtbar",
      "cellPurpose": "Zellzweck",
      "numeric": "Numerisch",
      "currency": "Währung",
      "date": "Datum",
      "list": "Bereit",
      "text": "Text",
      "catalogType": "Katalogtyp",
      "parameterName": "Name",
      "addParameter": "Parameter hinzufügen"
    },
    "messages": {
      "confirmTitle": "Beseitigen, abschütteln",
      "confirmDeleted": "Sind Sie sicher, es zu löschen?"
    }
  },
  "formDefinition": {
    "label": {
      "reconecting": "Wiederverbindung",
      "reconected": "Wieder verbunden"
    }
  },
  "inbox-notifications": {
    "title": {
      "inbox": "Briefkasten"
    },
    "label": {
      "message": "Botschaft",
      "messages": "Mitteilungen",
      "read": "Lesen",
      "inboxDate": "Datum",
      "ok": "JA",
      "no": "NICHT"
    }
  },
  "amendment-create": {
    "title": {
      "dialog-confirm": "Erklärung senden"
    },
    "label": {
      "taxReturn": "Nummer der zu berichtigenden Erklärung"
    },
    "messages": {
      "confirm": "Möchten Sie diese Aktion wirklich ausführen?"
    }
  },
  "statement-submit-amendment": {
    "title": {
      "page": "Anweisung korrigieren"
    },
    "label": {
      "taxReturn": "Erklärung",
      "year": "Zeitraum"
    },
    "messages": {},
    "validations": {},
    "button": {
      "file": "Beheben"
    }
  },
  "statement-submit-statement": {
    "title": {
      "page": "Steuererklärung einreichen",
      "subtitle": "Bitte vervollständigen Sie die Angaben, um die Steuer und den zu erklärenden Zeitraum zu bestimmen"
    },
    "label": {
      "fileStatement": "Steuererklärung einreichen",
      "taxReturn": "Erklärung von impuestos",
      "year": "Zeitraum"
    },
    "messages": {
      "formVersionNotFound": "Eine aktuelle und aktive Version wurde nicht gefunden",
      "taxReturnExist": "Die Erklärung ya existiert für diesen Zeitraum",
      "validPeriod": "Der ausgewählte Zeitraum gilt nicht für diese Steuer"
    }
  },
  "taxreturns": {
    "title": {
      "dialog-confirm": "Erklärung senden"
    },
    "messages": {
      "successfully": "Die Erklärung mit Punkt [period] wurde zufriedenstellend an [createDate] gesendet.",
      "successfullyApprovalRequired": "Da die Änderungserklärung die Steuer gesenkt hat, wird sie einem Überprüfungsverfahren zur Genehmigung oder Ablehnung durch die Steuerverwaltung unterzogen.",
      "confirm": "Möchten Sie diese Aktion wirklich ausführen?",
      "backToHome": "Zurück nach oben"
    }
  },
  "security-apikey": {
    "title": {
      "page": "API-Schlüssel"
    },
    "label": {
      "name": "Nobre",
      "new-api-key": "Neuer Schlüssel",
      "expiration": "Haltbarkeitsdatum",
      "your-pat": "Ihr neues persönliches Zugriffstoken",
      "revoke-token": "Token widerrufen"
    },
    "validations": {
      "name": "Der Name des API-Schlüssels ist erforderlich",
      "expiration": "Ablaufdatum ist erforderlich"
    },
    "message": {
      "key-created": "Stellen Sie sicher, dass Sie es speichern - Sie können nicht mehr darauf zugreifen.",
      "confirm-revoke": "Sind Sie sicher, dass Sie den Token widerrufen möchten?"
    }
  },
  "audit-log": {
    "title": {
      "event-title": "Ereignisprotokolle",
      "command-title": "Lagerprotokolle",
      "query-title": "Abfrageprotokolle",
      "http-title": "HTTP-Protokolle",
      "application": "App",
      "security": "Sicherheit"
    },
    "label": {
      "dateFrom": "Stammen aus",
      "dateTo": "Datum bis",
      "user": "Benutzer",
      "commandName": "Befehlsname",
      "successfullyExecuted": "Ejecución Exitosa",
      "aggregateName": "Namensabfrage",
      "queryName": "Entitätsname",
      "eventName": "Veranstaltungsname",
      "httpMethod": "HTTP-Methode",
      "httpStatusCode": "HTTP-Statuscode"
    },
    "header": {},
    "validations": {
      "dateRequired": "Dieses Datum ist erforderlich",
      "dateToGreaterThan": "Das Datum muss größer sein als das Ab-Datum",
      "dateLessThreeMonths": "Das Datum muss weniger als 3 Monate nach dem Ab-Datum liegen"
    },
    "messages": {}
  },
  "disable-tfa": {
    "label": {
      "title": "Deaktivieren Sie die Zwei-Faktor-Authentifizierung (2FA).",
      "disable": "Deaktivieren Sie 2FA"
    },
    "validations": {},
    "message": {
      "alert-1": "Diese Aktion deaktiviert nur 2FA.",
      "alert-2": "Durch Deaktivieren von 2FA werden die in Authentifizierungs-Apps verwendeten Schlüssel nicht geändert.",
      "alert-3": "Wenn Sie den in einer Authentifizierungs-App verwendeten Schlüssel ändern möchten, sollten Sie:",
      "alert-4": "Setzen Sie Ihre Authentifizierungsschlüssel zurück.",
      "success": "2fa wurde deaktiviert. Sie können 2fa wieder aktivieren, wenn Sie eine Authentifizierungs-App einrichten"
    }
  },
  "enable-authenticator": {
    "label": {
      "title": "Konfigurieren Sie die Authentifizierungs-App",
      "verification-code": "Verifizierungs-Schlüssel",
      "verification-code-digit": "Ziffer {{position}} von {{total}}",
      "verify": "prüfen",
      "manual-key": "Manueller Einrichtungsschlüssel",
      "copy-key": "Schlüssel kopieren",
      "key-copied": "Schlüssel wurde in die Zwischenablage kopiert.",
      "key-copied-button": "Kopiert",
      "copy-unavailable": "Der Schlüssel konnte nicht kopiert werden. Kopieren Sie ihn manuell.",
      "security-recommendations": "Sicherheitsempfehlungen",
      "security-recommendations-detail": "Bewahren Sie die Wiederherstellungscodes sicher auf und geben Sie den Einrichtungsschlüssel nicht weiter."
    },
    "validations": {
      "code": "Verifizierungs-Schlüssel ist erforderlich"
    },
    "message": {
      "instruction-1": "Laden Sie eine Authentifizierungs-App wie Microsoft Authenticator auf herunter",
      "and": "Ja",
      "or": "oder",
      "for": "damit",
      "instruction-2": "Scannen Sie den QR-Code oder geben Sie diesen Schlüssel ein",
      "instruction-3": "in Ihrer Authentifikator-App. Leerzeichen und Trennzeichen spielen keine Rolle.",
      "instruction-4": " Sobald Sie den QR-Code gescannt oder den obigen Schlüssel eingegeben haben, erhalten Sie von Ihrer Authentifizierungs-App einen eindeutigen Code. Geben Sie den Code in das Bestätigungsfeld unten ein."
    }
  },
  "recovery-codes": {
    "label": {
      "title": "Wiederherstellungscodes",
      "available-once": "Speichern Sie sie jetzt: Sie werden nicht erneut vollständig angezeigt."
    },
    "message": {
      "save-security-codes": "Bewahren Sie diese Codes an einem sicheren Ort auf.",
      "if-you-lose": "Wenn Sie Ihr Gerät verlieren und nicht über die Wiederherstellungscodes verfügen, verlieren Sie den Zugriff auf Ihr Konto."
    }
  },
  "generate-recovery-codes": {
    "label": {
      "title": "Generieren Sie Wiederherstellungscodes für die Zwei-Faktor-Authentifizierung (2FA)",
      "generate": "Generieren Sie Wiederherstellungscodes"
    },
    "validations": {},
    "message": {
      "alert-1": "Bewahren Sie diese Codes an einem sicheren Ort auf.",
      "alert-2": " Wenn Sie Ihr Gerät verlieren und nicht über die Wiederherstellungscodes verfügen, verlieren Sie den Zugriff auf Ihr Konto.",
      "alert-3": " Wenn Sie Ihr Gerät verlieren und nicht über die Wiederherstellungscodes verfügen, verlieren Sie den Zugriff auf Ihr Konto.",
      "alert-4": " Setzen Sie Ihre Authentifizierungsschlüssel zurück."
    }
  },
  "security-login": {
    "title": {
      "login": "Anmeldung"
    },
    "label": {
      "username": "Benutzer",
      "password": "Passwort",
      "rememberMe": "Mich erinnern",
      "loginButton": "Einloggen",
      "passwordRecovery": "Passwort wiederherstellen",
      "notRegistered": "Noch nicht registriert?",
      "signup": "Anmelden",
      "loginAlternative": "oder",
      "forgotPassword": " Haben Sie Ihr Passwort vergessen ?",
      "next": "Nächster",
      "forgotPasswordInstructions": "Geben Sie Ihren Benutzernamen ein und wir senden Ihnen eine E-Mail mit den Anweisungen zur Wiederherstellung",
      "externalLogin": "Externer Login",
      "captcha-placeholder": "Captcha eingeben"
    },
    "validations": {
      "usernameRequired": "Das Benutzerfeld ist erforderlich",
      "passwordRequired": "Passwort wird benötigt",
      "captchaValidationRequired": "Eine Captcha-Validierung ist erforderlich"
    }
  },
  "login-with-2fa": {
    "title": {
      "login": "Zwei-Faktor-Authentifizierung",
      "login-recovery": "Bestätigungscode abrufen"
    },
    "label": {
      "twoFactorCode": "Authentifizierungscode",
      "recoveryCode": "Wiederherstellungscode",
      "rememberBrowser": "Denken Sie an diesen Browser",
      "verificationCodeInstructions": "Geben Sie den sechsstelligen Code aus Ihrer Authentifizierungs-App ein, um fortzufahren.",
      "loginButton": "Anmeldung",
      "loginRecovery": "Melden Sie sich mit dem Wiederherstellungscode an"
    },
    "message": {
      "no-access": "Sie haben keinen Zugriff auf Ihr Authentifizierungsgerät? Sie können",
      "trustedBrowser": "Überspringen Sie die Bestätigung in diesem vertrauenswürdigen Browser.",
      "recovery-requested": " Sie haben angefordert, sich mit einem Wiederherstellungscode anzumelden. Diese Anmeldung wird erst gespeichert, wenn Sie beim Anmelden einen Authentifizierungs-App-Code angeben oder 2FA deaktivieren und erneut anmelden."
    },
    "validations": {
      "twoFactorCode": "Das Feld Authentifizierungscode ist erforderlich",
      "recoveryCode": "Das Wiederherstellungscodefeld ist erforderlich"
    }
  },
  "security-password-recovery": {
    "label": {
      "title": "Passwort wiederherstellen",
      "changePassword": "Kennwort ändern",
      "userName": "Benutzer",
      "newPassword": "Neues Kennwort",
      "repeatPassword": "Wiederhole das Passwort",
      "returnLogin": "Zurück zum Login"
    },
    "message": {
      "email-sended": "E-Mail zur Kennwortwiederherstellung gesendet",
      "password-changed": "Das Passwort wurde erfolgreich geändert"
    },
    "validations": {
      "newPassword": "Das neue Passwort muss mindestens 6 Zeichen lang sein",
      "passwordEqual": "Passwörter stimmen nicht überein"
    }
  },
  "reset-authenticator": {
    "label": {
      "title": "Installieren Sie die Authentifizierungs-App",
      "reset": "Authentifizierungsschlüssel zurücksetzen",
      "configure": "Konfigurieren Sie die Authentifizierungs-App"
    },
    "validations": {},
    "message": {
      "alert-1": "Wenn Sie Ihren Authentifizierungsschlüssel zurücksetzen, funktioniert Ihre Authentifizierungs-App erst, wenn Sie sie neu konfigurieren.",
      "alert-2": "Dieser Prozess deaktiviert 2FA, bis Sie Ihre Authentifizierungs-App überprüfen.",
      "alert-3": "Wenn Sie die Konfiguration Ihrer Authentifizierungs-App nicht abschließen, verlieren Sie möglicherweise den Zugriff auf Ihr Konto.",
      "success": "Ihr Authentifizierungsschlüssel wurde zurückgesetzt und Sie müssen Ihre Authentifizierungs-App mit dem neuen Schlüssel konfigurieren."
    }
  },
  "tfa": {
    "title": {
      "page": "Doppelfaktorauthentifizierung"
    },
    "label": {
      "title": "Zwei-Faktor-Authentifizierung (2FA)",
      "authenticator-app": "Authenticator App",
      "setup-authenticator": "Konfigurieren Sie die Authentifizierungs-App",
      "add-authenticator": "Authentifizierungs-App hinzufügen",
      "reset-authenticator": "Starten Sie die Authentifizierungs-App neu",
      "reset-recovery-codes": "Wiederherstellungscodes zurücksetzen",
      "disable-2fa": "Deaktivieren Sie 2FA",
      "forget-this-browser": "Vergiss diesen Browser",
      "status-enabled": "Aktiviert",
      "status-disabled": "Nicht eingerichtet",
      "recovery-codes-remaining": "Wiederherstellungscodes verfügbar",
      "danger-zone": "Kritische Aktionen"
    },
    "validations": {},
    "message": {
      "two-factor-forgotten": "Dieser Browser wurde vergessen. Wenn Sie sich in diesem Browser erneut anmelden, werden Sie nach Ihrem 2fa-Code gefragt.",
      "no-codes-left-1": "Sie haben keine Wiederherstellungscodes verfügbar.",
      "no-codes-left-2": "Sollte",
      "no-codes-left-3": "Generieren Sie einen neuen Satz von Wiederherstellungscodes",
      "no-codes-left-4": "bevor Sie sich mit einem Wiederherstellungscode anmelden können.",
      "some-codes-left-1": "Haben",
      "some-codes-left-2": "Wiederherstellungscode (s) verfügbar.",
      "some-codes-left-3": "Sollte",
      "some-codes-left-4": "Generieren Sie einen neuen Satz von Wiederherstellungscodes"
    }
  },
  "roles": {
    "account_reports": "Kontoberatung",
    "catalogs_admin": "Katalogmanager",
    "details_reports": "Berichtsdetail",
    "environments_admin": "Manager für Umgebungsvariablen",
    "forms_admin": "Formular-Manager",
    "management_report_admin": "Berichts-Manager",
    "notifications_admin": "Benachrichtigungs-Manager",
    "system_auditor": "System Auditor",
    "taxpayer_reports": "Beitragsberatungen",
    "taxpayers_admin": "Beitragsadministrator",
    "payments_admin": "Zahlungsmanager",
    "taxpayers_approver": "Mitwirkender Genehmiger",
    "taxreturn_approver": "Genehmiger von Erklärungen",
    "taxreturn_reports": "Deklarationsabfragen",
    "tfa_admin": "2FA Administrator",
    "users_admin": "Benutzer Manager",
    "current_account_admin": "Girokonto-Manager"
  },
  "taxes": {
    "title": {
      "page": "Steuern verwalten"
    },
    "label": {
      "name": "Name",
      "rateType": "Tarifart",
      "shortName": "Kurzer Name",
      "code": "Code",
      "newButton": "Neu",
      "saveButton": "Behalten",
      "tabEditTax": "Allgemeines",
      "tabRates": "Gebühren",
      "tabPeriodicity": "Periodizität",
      "dateFrom": "Daten von",
      "dateTo": "Datum bis",
      "value": "Wert",
      "periodicityType": "Periodizitätstyp",
      "filingDueDay": "Verfallsdatum"
    },
    "header": {
      "code": "Code",
      "name": "Name",
      "rateType": "Tarifart",
      "value": "Wert",
      "dateFrom": "Daten von",
      "dateTo": "Datum bis",
      "shortName": "Kurzer Name",
      "actions": "Aktionen",
      "periodicityType": "Periodizitätstyp",
      "filingDueDay": "Verfallsdatum"
    },
    "validations": {
      "rateTypeRequired": "Das Feld für den Tariftyp ist erforderlich",
      "shortNameRequired": "Das Kurznamenfeld ist erforderlich",
      "codeRequired": "Das Codefeld ist erforderlich",
      "valueLessThan100": "Das Wertefeld muss kleiner als 100% sein",
      "valueRequired": "Das Wertefeld ist erforderlich",
      "dateFromRequired": "Das Datum vom Feld ist erforderlich",
      "dateToRequired": "Das Datum bis zum Feld ist erforderlich",
      "filingDueDayRequired": "Das Feld Ablauftag ist erforderlich",
      "periodicityTypeRequired": "Das Feld für den Periodizitätstyp ist erforderlich"
    },
    "messages": {
      "savedSuccessfully": "Wurde erfolgreich gespeichert",
      "deletedSuccessfully": "Wurde erfolgreich entfernt",
      "error": "Error"
    }
  },
  "reportOperation": {
    "title": {
      "page": "Betriebsberichte verwalten",
      "warning": "Warnung"
    },
    "label": {
      "operation": "Operation",
      "report": "Bericht"
    },
    "header": {
      "operation": "Operation",
      "report": "Bericht",
      "actions": "Aktionen"
    },
    "messages": {
      "removeReportOperation": "Sind Sie sicher, es zu löschen?"
    }
  },
  "report-cells": {
    "title": {
      "page": "Boxen"
    },
    "label": {
      "code": "Box Code",
      "name": "Namensfeld",
      "description": "Beschreibung",
      "formula": "Formel",
      "order": "Auftrag",
      "type": "Nett",
      "numeric": "Numerisch",
      "currency": "Währung",
      "date": "Datum",
      "list": "Bereit",
      "text": "Text",
      "catalogType": "Katalogtyp"
    },
    "messages": {
      "confirmTitle": "Beseitigen, abschütteln",
      "confirmDeleted": "Möchten Sie es wirklich löschen?"
    }
  },
  "reports": {
    "title": {
      "page": "Berichte verwalten",
      "report": "Bericht",
      "versions": "Versionen"
    },
    "label": {
      "name": "Name",
      "shortName": "Kurzer Name",
      "code": "Code",
      "newButton": "Neu",
      "saveButton": "Behalten",
      "tabEditReport": "Allgemeines",
      "tabPeriodicity": "Periodizität",
      "dateFrom": "Daten von",
      "dateTo": "Datum bis",
      "periodicityType": "Periodizitätstyp",
      "filingDueDay": "Verfallsdatum"
    },
    "header": {
      "code": "Code",
      "name": "Name",
      "shortName": "Kurzer Name",
      "actions": "Aktionen",
      "dateFrom": "Daten von",
      "dateTo": "Datum bis",
      "periodicityType": "Periodizitätstyp",
      "filingDueDay": "Verfallsdatum"
    },
    "validations": {
      "shortNameRequired": "Das Kurznamenfeld ist erforderlich",
      "codeRequired": "Das Codefeld ist erforderlich",
      "dateFromRequired": "Das Datum vom Feld ist erforderlich",
      "dateToRequired": "Das Datum bis zum Feld ist erforderlich",
      "filingDueDayRequired": "Das Feld Verfalltag ist erforderlich",
      "periodicityTypeRequired": "Das Feld für den Periodizitätstyp ist erforderlich"
    },
    "messages": {
      "savedSuccessfully": "Wurde erfolgreich gespeichert",
      "deletedSuccessfully": "Wurde erfolgreich entfernt",
      "error": "Error"
    }
  },
  "taxpayer-current-account": {
    "title": {
      "currentAccount": "Aktuelles Konto",
      "amendingCredit": "Kontostandsanfrage",
      "currentAccountTransaction": "Transaktionsdetails",
      "transactionAdjustment": "Balance-Einstellung"
    },
    "label": {
      "tax": "MwSt",
      "taxCode": "Kabeljau. MwSt",
      "period": "Zeitraum",
      "taxAmount": "Steuerbetrag",
      "penalty": "Bußgeld",
      "interest": "Interessen",
      "taxArrears": "Mora",
      "total": "Gesamt",
      "expirationDate": "Haltbarkeitsdatum",
      "accountType": "Konto Typ",
      "balance": "Balance",
      "date": "Datum",
      "transactionType": "Art der Transaktion",
      "value": "Wert",
      "document": "Dokument",
      "justification": "Rechtfertigung",
      "credit": "Gutschrift",
      "debit": "Lastschrift"
    },
    "dialog": {},
    "messages": {},
    "validations": {}
  },
  "taxpayer-payments": {
    "title": {
      "page": "Zahlungsanfrage",
      "pagePayments": "Zahlungs Aufzeichnung",
      "selectTaxReturn": "Steuererklärung auswählen"
    },
    "label": {
      "registerPayment": "Zahlungs Aufzeichnung",
      "amountTaxReturn": "Deklarationsbetrag",
      "totalDebt": "Gesamtschulden",
      "tax-id": "Ruc",
      "name": "Name",
      "date-from": "Stammen aus",
      "date-to": "Datum bis",
      "date-payment": "Zahltag",
      "payment-number": "Zahlungsnummer",
      "exchange-rate": "Tauschrate",
      "local-amount": "Betrag in Landeswährung",
      "tax": "MwSt",
      "amount": "Menge",
      "swiftNumber": "SWIFT-Bestätigungsnummer"
    },
    "messages": {
      "paymentRegisteredSucessfully": "Zahlung erfolgreich registriert am [createDate]",
      "paymentInformationWarning": "Bei Nichtbereitstellung der Angaben zum Swift-Code kann die Zahlung nicht korrekt identifiziert werden und die Erklärung gilt als unbezahlt"
    }
  },
  "taxpayer-report": {
    "title": {
      "page": "Beitragsberatung"
    },
    "label": {
      "name": "Name",
      "nit": "Steuer ID",
      "county": "Land",
      "personType": "Art von Person",
      "email": "Mail"
    }
  },
  "taxpayer-request": {
    "label": {
      "personType": "Personentyp",
      "businessName": "Name oder sozialer Grund",
      "fullName": "Vollständiger Name",
      "id": "Identifikationsnummer",
      "taxNumber": "Steuernummer",
      "phoneNumber": "Telefonnummer",
      "domicile": "Adresse",
      "department": "Abteilung / Provinz / Staat",
      "addContact": "Kontakt hinzufügen",
      "operations": "Operationen",
      "contacts": "Kontakte:",
      "taxVector": "Steuervektor",
      "reportVector": "Berichte",
      "generalData": "Allgemeines",
      "tax": "MwSt",
      "taxObligation": "MwSt",
      "report": "Bericht",
      "website": "Webseite",
      "idTax": "Steueridentifikationsnummer im Wohnsitzland",
      "contactName-tax": "Name des primären Kontakts",
      "docNumberContact-tax": "Kontakt-Identifikationsnummer",
      "contactTaxIdNumber-tax": "Steueridentifikationsnummer des Kontakts im Wohnsitzland",
      "phoneNumberContact-tax": "Telefonnummer des Kontakts im Wohnsitzland",
      "email-tax": "Kontakt E-mail",
      "documents": "Unterlagen",
      "docCompanyRegistrationNumber": "Firmenregistrierungsdokument",
      "docLocalContact": "Ausweis des Kontakts im Wohnsitzland",
      "acceptance": "Annahme",
      "taxpayerRequest": "POSS-Registrierung",
      "confirmTerms": "Nutzungsbedingungen akzeptieren",
      "terms": "Lorem ipsum Schmerz sitzen amet consectetur adipiscing elit per",
      "locale": "Vordefinierte Sprache",
      "close": "Verlassen",
      "acquirerId": "Erwerber-ID",
      "acquirerCountry": "Erwerberland",
      "terminalId": "Terminal-ID",
      "merchantCategoryCode": "Händlerkategorie-Code",
      "merchantId": "Händler-ID",
      "documentNumberCountryResidence": "Dokumentnummer im Land des Wohnsitzes"
    },
    "vector": {
      "label": {
        "tax": "MwSt",
        "expiration": "Verfallsdatum",
        "periodicity": "Periodizität",
        "startOperation": "Inbetriebnahme"
      }
    },
    "dialog": {},
    "messages": {
      "contacts": "Weitere Kontakte sind erforderlich",
      "operations": "Es ist mindestens eine Operation erforderlich",
      "selectOperations": "Wählen Sie die entsprechenden Operationen aus",
      "withoutOperations": "Keine Vorgänge",
      "withoutOperationsVector": "Aufgrund Ihrer ausgewählten Vorgänge müssen Sie keinen Steuervektor darstellen",
      "withoutOperationsReport": "Aufgrund der ausgewählten Vorgänge kann kein Bericht angezeigt werden.",
      "withoutDocuments": "Es gibt keine Dateidefinition",
      "successRegistrationTaxpayerTitle": "Ihre Registrierungsanfrage wurde abgeschlossen und erfolgreich empfangen.",
      "successRegistrationTaxpayerSubTitle": "Sie werden analysiert und erhalten Ihre Ergebnisse per E-Mail.",
      "email-tax-info": "Diese E-Mail-Adresse wird verwendet, um Ihren Benutzernamen und Ihr Passwort zu erhalten, sobald Ihr Antrag genehmigt wurde. Bitte überprüfen Sie, ob die angegebenen Informationen korrekt sind.",
      "contactsList": "Registrieren Sie hier Ihre sekundären Kontakte. Sie müssen mindestens einen registrieren",
      "noContacts": "Es wurden keine Kontakte angegeben"
    },
    "validations": {
      "acceptance": "Feld muss ausgewählt sein",
      "formComplete": "Füllen Sie das gesamte Formular aus"
    }
  },
  "taxpayer-request-val": {
    "title": {
      "page": "Anträge der Steuerzahler",
      "approve": "Anfrage genehmigen",
      "reject": "Anfrage ablehnen",
      "request-additional-info": "Fordern Sie zusätzliche Informationen an",
      "cancellationDate": "Cancellation date"
    },
    "label": {
      "date-from": "Stammen aus",
      "date-to": "Datum bis",
      "request-type": "Art der Anfrage",
      "request": "Anfrage",
      "type": "Nett",
      "taxpayer": "Beitrag",
      "state": "Zustand",
      "approve": "Bestehen",
      "reject": "Ablehnen",
      "request-additional-info": "Fordern Sie zusätzliche Informationen an",
      "comments": "Bemerkungen",
      "reason": "Ursache",
      "cancellationDate": "Stornierungsdatum"
    },
    "message": {
      "approved": "Antrag genehmigt",
      "rejected": "Abgelehnte Anfrage",
      "request-additional-info": "Fordern Sie zusätzliche Informationen an",
      "unsubscribe-request": "Ihre Bewerbung ist eingegangen, Sie werden benachrichtigt, ob Ihre Bewerbung genehmigt oder abgelehnt wurde."
    }
  },
  "taxpayer-taxreturns": {
    "title": {
      "page": "Berichte zu Steuererklärungen anzeigen",
      "subtitle": "Liste der gespeicherten Dokumente",
      "amendment": "Berichtigung der Steuererklärung einreichen"
    },
    "label": {
      "nit": "Steuer ID",
      "taxreturnNumber": "Deklarationsnummer",
      "country": "Land",
      "formId": "Formularname",
      "taxreturnType": "Deklarationstyp",
      "taxreturnStatus": "Zustand",
      "name": "Mitwirkender Name",
      "period": "Zeitraum",
      "periodFrom": "Stammen aus",
      "periodTo": "Datum bis",
      "active": "Aktiv",
      "overview": "Allgemeines",
      "taxreturn": "Erklärung",
      "createDate": "Datum",
      "approve": "Genehmigt",
      "comments": "Bemerkungen"
    },
    "header": {
      "actions": "Aktionen",
      "nit": "Steuer ID",
      "name": "Mitwirkender Name",
      "taxReturnNumber": "Deklarationsnummer",
      "createDate": "Datum",
      "taxreturnType": "Deklarationstyp",
      "taxreturnStatus": "Zustand",
      "form": "Bilden",
      "period": "Zeitraum",
      "active": "Aktiv",
      "rejectionReason": "Grund für die Ablehnung"
    },
    "validations": {},
    "messages": {},
    "button": {}
  },
  "taxpayer-update-request": {
    "title": {
      "page": "Registrierung aktualisieren"
    }
  },
  "taxpayer-unsuscribe-request": {
    "title": {
      "page": "Ausfallen"
    }
  },
  "form-administration": {
    "title": {
      "page": "Verwaltungsformular für Erklärungen",
      "form": "Bilden",
      "versions": "Versionen"
    },
    "label": {
      "code": "Code",
      "name": "Name",
      "shortName": "Kurzer Name",
      "tax": "MwSt",
      "numberModifications": "Anzahl der Änderungen",
      "amendmentApprovalRequired": "Änderungen bedürfen der Genehmigung",
      "form": "Bilden",
      "versions": "Versionen"
    },
    "header": {
      "actions": "Aktionen",
      "code": "Code",
      "name": "Name",
      "shortName": "Kurzer Name",
      "tax": "MwSt"
    },
    "messages": {
      "confirmTitle": "Beseitigen, abschütteln",
      "confirmDeleted": "Sind Sie sicher, es zu löschen?",
      "noCellDefined": "Sehr geehrter Steuerzahler, dieses Formular ist unvollständig definiert. Wenden Sie sich an den Administrator"
    }
  },
  "taxpayer-alternate-user": {
    "title": {
      "page-add": "Neuer alternativer Benutzer",
      "page-list": "Alternative Benutzer"
    },
    "label": {
      "add-user": "Benutzer hinzufügen"
    }
  },
  "login": {
    "hero": {
      "title": "Modernisierung und Kooperation für die Herausforderungen der Besteuerung in der",
      "name": "Digitalen Wirtschaft"
    },
    "block1": {
      "title": "Eine strategische Plattform",
      "text": "für Steuerverwaltungen"
    },
    "block2": {
      "title": "Ein effektives Werkzeug",
      "text": "zur Verwaltung der Besteuerung von Unternehmen ohne physische Vertretung im jeweiligen Land."
    },
    "block3": {
      "title": "Zur Erleichterung",
      "text": "der Registrierung, Einreichung und Zahlung von Steuern durch ausländische digitale Anbieter."
    },
    "links": {
      "title": "Weitere Informationen",
      "link1": "Materialien und Verfahren",
      "link2": "Über CIAT",
      "link3": "Über PITAA"
    }
  },
  "appMenu": {
    "taxpayer-payment-view": "Siehe Zahlungen",
    "taxpayer-profile-update": "Registrierung aktualisieren",
    "unsubscribe-request-taxpayer": "Abmelden",
    "taxpayer-payment-record": "Zahlungsbeleg",
    "taxpayer-amending-credit": "Schuldsaldo",
    "security-taxpayer": "Sicherheit",
    "apikey": "API-Schlüssel",
    "two-factor-authentication-taxpayer": "Zwei-Faktor-Authentifizierung",
    "taxpayer-profile": "Profil",
    "inbox-notifications": "Benachrichtigungen",
    "statements": "Steuererklärungen",
    "file-tax-statements": "Steuererklärung einreichen",
    "file-report": "Ergänzender Bericht einreichen",
    "taxpayer-taxreturn-payments": "Zahlungen",
    "amendment-taxreturn": "Änderung der Steuererklärung",
    "taxpayer-tax-returns": "Steuererklärungen auflisten",
    "taxpayer-report-details": "Zusatzberichte auflisten"
  }
}
